import React from 'react';
import { Box, Grid, Tabs, Tab } from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import AutorizacionTextos from '../organisms/AutorizacionTextos';
import useMediaQuery from '@mui/material/useMediaQuery';
import EstadoSolicitudes from '../organisms/EstadoSolicitudes';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

export const TraduccionesAdmin = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const matches = useMediaQuery('(min-width:600px)');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid
            container
            direction="column"
            sx={{
                height: 'auto',
            }}
        >
            <Grid item xs>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="fullWidth"
                        textColor="primary"
                        indicatorColor="primary"
                    >
                        <Tab
                            sx={{ paddingTop: '17.5px', paddingBottom: '17.5px' }}
                            label="Autorizacion de Textos"
                            {...a11yProps(0)}
                        />
                        <Tab
                            sx={{ paddingTop: '17.5px', paddingBottom: '17.5px' }}
                            label="Estado de Solicitudes"
                            {...a11yProps(1)}
                        />
                    </Tabs>
                </Box>
            </Grid>
            <Grid item xs>
                <Box sx={{ px: matches ? 2 : 0 }}>
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <AutorizacionTextos />
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <EstadoSolicitudes />
                    </TabPanel>
                </Box>
            </Grid>
        </Grid>
    );
};

export default TraduccionesAdmin;
